import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MetisMenu from "@metismenu/react";
import adminMenus from "../../route/adminMenu";
import agentMenus from "../../route/agentMenu";
import menus from "../../route/menu";
import HomeModel from "../../models/HomeModel";
import AppCookie from "../../helpers/AppCookie";
import { useDispatch } from "react-redux";
import { 
  RiBuilding4Line, 
  RiHistoryLine, 
  RiWallet3Line, 
  RiVipCrownLine,
  RiSmartphoneLine,
  RiBarChartBoxLine
} from "react-icons/ri";

function AsideMenu() {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname || '/bank';
  const isAdminPage = currentPath.includes("admin");
  const [data, setData] = useState([]);

  const isAgent = () => {
    try {
      let userStr = AppCookie.getCookie('user') ?? '{}';
      if (userStr) {
        const user = JSON.parse(userStr);
        return user.role === 2;
      }
    } catch (e) {}
    return false;
  };

  const handleLinkClick = (path) => {
    dispatch({ type: "RESET_MENU_SELECTION", payload: null });
    if (window.innerWidth <= 768) {
      dispatch({ type: "SHOW_SIDEBAR", payload: false });
    }
    localStorage.setItem("activeMenu", path);
  };

  useEffect(() => {
    HomeModel.getInfoHeader().then((res) => setData(res.data || {})).catch(() => {});
  }, []);

  const getAdminMenus = () => {
    if (isAgent()) {
      return agentMenus;
    }
    return adminMenus;
  };

  const getMenuIcon = (menuId) => {
    switch (menuId) {
      case 'bank':
        return <RiBuilding4Line size={18} />;
      case 'transaction-history':
        return <RiHistoryLine size={18} />;
      case 'deposit':
        return <RiWallet3Line size={18} />;
      case 'app-guide':
        return <RiSmartphoneLine size={18} />;
      case 'xsmb':
        return <RiBarChartBoxLine size={18} />;
      case 'vip-user':
        return <RiVipCrownLine size={18} />;
      default:
        return <RiBuilding4Line size={18} />;
    }
  };

  return (
    <MetisMenu className="metismenu mt-2" id="menu">
      <div className="custom-menu-title">
        <span>Không Gian Làm Việc</span>
      </div>
      {!isAdminPage && menus.map((menu, key) => {
        if (menu.id === "vip-user" && !data.is_vip) return null;
        const isActive = currentPath === menu.path || (menu.path === '/bank' && currentPath === '/');
        return (
          <li className={`p-0 m-0 ${isActive ? "bank-menu-active" : ""}`} key={key}>
            <Link 
              to={menu.path} 
              className={`custom-link ${isActive ? "active" : ""}`} 
              onClick={() => handleLinkClick(menu.path)}
            >
              <span className="menu-icon custom-color-icon">
                {getMenuIcon(menu.id)}
              </span>
              <span className="nav-text">{menu.text}</span>
            </Link>
          </li>
        );
      })}
      {isAdminPage && getAdminMenus().map((menu, key) => {
        const isActive = currentPath === menu.path;
        return (
          <li className={`p-0 m-0 ${isActive ? "bank-menu-active" : ""}`} key={key}>
            <Link to={menu.path} className={`custom-link ${isActive ? "active" : ""}`}>
              <div className="menu-icon custom-color-icon" dangerouslySetInnerHTML={{ __html: menu.icon }}></div>
              <span className="nav-text">{menu.text}</span>
            </Link>
          </li>
        );
      })}
    </MetisMenu>
  );
}

export default AsideMenu;
